import React from 'react';

import MemoryTags from '../MemoryCard/Tags';

import { formatDate } from '../../helpers';

import type { Memory } from '../../types/memory';

const MemoryMeta: React.FC<{ memory: Memory }> = ({ memory }) => {
  return (
    <div className="memory-meta wa-cluster">
      {memory.date && (
        <wa-tag className="memory-date">
          <wa-icon name="calendar" variant="regular" label="Date"></wa-icon>
          {formatDate(memory.date)}
        </wa-tag>
      )}
      <wa-tag className="memory-dedicated-to">
        <wa-icon name="user" variant="regular" label="Dedicated to"></wa-icon>
        {memory.dedicated_to}
      </wa-tag>
      <MemoryTags tags={memory.tags.map(tag => tag.id)} size="m" readOnly />
    </div>
  );
}

export default MemoryMeta;
